/**
 * CollapseAllIcon/index.js
 * desc: system icon used to collapse all content
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CollapseAllIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="collapse-all icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.collapseAll.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18.462 0H4.615C3.77 0 3.077.846 3.077 1.88v1.197H1.538C.692 3.077 0 3.923 0 4.957V18.12C0 19.154.692 20 1.538 20h13.847c.846 0 1.538-.846 1.538-1.88V4.957c0-1.034-.692-1.88-1.538-1.88H4.615V1.88h13.847v13.162h-1.538v1.881h1.538c.846 0 1.538-.846 1.538-1.88V1.88C20 .846 19.308 0 18.462 0zM1.538 18.12h13.847V4.958H1.538V18.12zm2.629-6.096H12.5v-1.19H4.167v1.19z"/></svg>
    </IconButton>
);



export default CollapseAllIcon;
